export enum DashboardType {
    BUDGET_TASKS = 'BudgetTasks',
    YOY_COMPARISON = 'YoYComparison',
    ANNUAL_SUMMARY = 'AnnualSummary',
}